import React from 'react';
import CardGroupHeader from './components/CardGroupHeader';
import CardGroupLeftPanel from './components/CardGroupLeftPanel';
import { Points } from 'components/Points/Points';
import { AssetUrls } from 'config/assets';
import './CardGroupContainer.css';

interface CardItemProps {
  image: string;
  points: number;
}

const CardItem: React.FC<CardItemProps> = ({ image, points }) => (
  <div className="card-item">
    <img className="card-item-image" src={image} alt="card" />
    <div className="card-item-points">
      <Points points={points} type="small" />
    </div>
  </div>
);

interface CardGroupContainerProps {
  title: string;
  artistName?: string;           // For printings mode
  userName?: string;             // For send mode
  userAvatar?: string;           // For send mode
  userPoints?: number;           // For send mode
  lowPrice?: number;            // For printings
  highPrice?: number;           // For printings
  totalValue?: number;          // For send page
  autoMatch?: boolean;          // For send page
  onAutoMatchToggle?: (val: boolean) => void; // For send page
  mode?: 'printings' | 'send';
  onRemoveAll?: () => void;
  onSend?: () => void;
  onReset?: () => void;
  isRemoved?: boolean;
  children?: React.ReactNode;
}

const CardGroupContainer: React.FC<CardGroupContainerProps> = ({
  title,
  artistName,
  userName,
  userAvatar,
  userPoints,
  lowPrice = 0,
  highPrice = 0,
  totalValue = 0,
  autoMatch = false,
  onAutoMatchToggle,
  mode = 'printings',
  onRemoveAll,
  onSend,
  onReset,
  isRemoved = false,
  children,
}) => {
  const placeholderCards = [
    { image: AssetUrls.sampleCards.llanowarElves, points: 1903000 },
    { image: AssetUrls.sampleCards.timeWalk, points: 1903000 },
    { image: AssetUrls.sampleCards.serraAngel, points: 1903000 },
    { image: AssetUrls.sampleCards.territorialHellkite, points: 1903000 },
  ];

  return (
    <div className="card-group-container">
      {mode === 'send' ? (
        <CardGroupLeftPanel 
          userName={userName || 'Unknown User'} 
          userAvatar={userAvatar || AssetUrls.profile.avatar1} 
          userPoints={userPoints || 0} 
          onRemoveAll={onRemoveAll}
          onSend={onSend}
          onReset={onReset}
          isRemoved={isRemoved}
        />
      ) : (
        <CardGroupLeftPanel 
          userName={artistName || 'Unknown Artist'} 
          userAvatar={AssetUrls.profile.avatar1} 
          userPoints={0} 
          onRemoveAll={onRemoveAll} 
        />
      )}
      <div className="card-group-right">
        <CardGroupHeader
          title={title}
          lowPrice={lowPrice}
          highPrice={highPrice}
          totalValue={totalValue}
          autoMatch={autoMatch}
          onAutoMatchToggle={onAutoMatchToggle}
          mode={mode}
        />
        <div className="card-group-body">
          {children || (
            <div className="card-grid">
              {placeholderCards.map((card, index) => (
                <CardItem key={index} image={card.image} points={card.points} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardGroupContainer;
